// extracted by mini-css-extract-plugin
module.exports = {"openModalBtn":"ChangeClinic_openModalBtn__3tcdM","footer":"ChangeClinic_footer__13ssT"};